export default "__VITE_ASSET__DJxJSJsm__"